import { useContext } from 'react'
import { PrintContext } from '../../provider/printable-pdf-context.provider'


export const usePrintablePdf = () => useContext(PrintContext);
